module.exports = __webpack_public_path__ + "img/Swiatlo.70d46c4e.png";